//Accordion
(function ($) {
    function reviewsSlider() {

        const googleReviewsSwiper = new Swiper('.reviews-slider > .container', {
            // Optional parameters
            modules: [SwiperNavigation],
            loop: false,
            slidesPerView: 1,
            spaceBetween: 32,
            speed: 500,
            navigation: {
                nextEl: '.reviews-slider__list-nav-next',
                prevEl: '.reviews-slider__list-nav-prev',
            },

            breakpoints: {
                // when window width is >= 767px
                767: {
                    slidesPerView: 2
                },
                // when window width is >= 640px
                1199: {
                    slidesPerView: 3
                }
            }
          });
    }

    reviewsSlider();
})(jQuery);